export default __webpack_public_path__ + "static/banner-pattern-1-124c783398e8afbaf0e3aa5ae4ce4bc3.png";